import { useEffect } from "react";
import { FORESYTS_LOGIN_URL } from "../../../common/constants";

// Login happens on the parent platform (foresyts.ai), not in this app.
// It redirects back here with ?token=, which App.js picks up, decodes,
// and uses to log the user in - see the useEffect there. Landing on "/"
// with no token means the user never came from that redirect, so send
// them there instead of showing a form that can't actually check anything.
const Login = () => {
  useEffect(() => {
    const hasToken = new URLSearchParams(window.location.search).get("token");
    const isLocal = process.env.NODE_ENV === "development";
    if (!hasToken && !isLocal) {
      window.location.replace(FORESYTS_LOGIN_URL);
    }
    // If a token is present, App.js's own effect decodes it, logs the user
    // in, and navigates to /dashboard - this component just needs to not
    // race it to foresyts.ai in the meantime. In local dev there's no form
    // here to show either way, so let App.js's LOCAL_DEV_TOKEN fallback
    // (see App.js) resolve instead of bouncing to the production site.
  }, []);

  return null;
};

export default Login;
